<template>
  <div class="wrapper">
    <side-bar type="sidebar" :sidebar-links="this.sidebarLinks"> </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
  },
  data() {
    return {
      sidebarLinks: [],
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$forceUpdate();

      this.sidebarLinks = this.$sidebar.sidebarLinks;

      let lastupdatedtime = localStorage.getItem("lastupdatedtime");

      let now = new Date().getTime();

      let a = localStorage.getItem("isloded");

      if (!a && now - lastupdatedtime > 1000 * 60 * 60) {
        localStorage.setItem("isloded", "true");
        localStorage.setItem("lastupdatedtime", new Date().getTime());
        location.reload();
      } else {
        localStorage.removeItem("isloded");
        localStorage.removeItem("lastupdatedtime");
        lastupdatedtime = now;
      }
    }, 0);

    this.sidebarLinks = this.$sidebar.sidebarLinks;
    // const links = this.$sidebar.sidebarLinks
    // const currentUserRole = localStorage.getItem('role')
    // for (let link in links){
    //   const allowedRoles = links[link].allowedRoles
    //   console.log("allowedRoles", allowedRoles)
    //   if (allowedRoles.includes(currentUserRole)) {
    //     this.sidebarLinks.push(links[link])
    //   }
    // }
    // console.log("side bar links", this.sidebarLinks)
  },
};
</script>
